<template>
    <div class="cart-box" v-show="showCart" @click.stop.prevent="closeBox">
        <template v-for="itemA in cartS">
            <section class="cart-box-wrap" @click.prevent.stop="" v-show="cartContentBox">
                <div class="cart-box-tab" v-if="cartS.length>1">
                    <template v-for="n in cartS.length">
                        <span :class="activeTab==cartS[n-1].cartVal?'active':''" @click.prevent="tabSwitch(cartS[n-1].cartVal)">{{cartS[n-1].cartName}}</span>
                    </template>
                </div>
                <div class="cart-box-header">
                    <p v-if="getPlatFrom == 'lc'" v-html="itemA.cartVal=='quick'?'小伙伴,<b>极速达专区</b>商品需独立结算哦～':'为保证配送温度，<b>低温</b>和<b>常温</b>商品需分开配送'"></p>
                </div>
                <div class="cart-box-container">
                    <template v-if="itemA.coldChainCart.products.concat(itemA.coldChainCart.promotions).length>0">
                        <div class="cart-section">
                            <div class="cart-section-title">
                                <p><em>•</em>{{itemA.cartVal=='quick'?'极速达':'冷藏商品'}}</p>
                                <span>{{itemA.cartVal=='quick'?itemA.quickMsg:itemA.coldMsg}}</span>
                            </div>
                            <div class="cart-section-content">
                                <div v-for="itemP in itemA.coldChainCart.products" class="item" :class="'item-'+setId(itemP.speedUp)+itemP.proId">
                                    <p>
                                        <span>{{itemP.proName}}</span>
                                        <template v-if="itemA.cartVal=='quick'">
                                            <i style="display: none;" :class="'cart-pro-store-'+setId(itemP.speedUp)+itemP.proId">仅{{itemP.stockCount}}件</i>
                                        </template>
                                        <template v-else>
                                            <i v-if="itemP.delayDays>0" :class="'cart-pro-delay-'+setId(itemP.speedUp)+itemP.proId">延迟配送</i>
                                        </template>
                                    </p>
                                    <proOpera :itemPro="itemP" :fromState="fromState" :speedUp="itemP.speedUp" :stockCount="itemP.stockCount" :proId="itemP.proId" :promoId="itemP.promotionId" :protype="4" :proLimit="itemP.limitBuyCount" :proName="itemP.proName"></proOpera>
                                </div>
                                <div v-for="itemP in itemA.coldChainCart.promotions" class="item" :class="'item-'+setId(itemP.speedUp)+itemP.promotionId">
                                    <p>
                                        <span>{{itemP.promotionName}}</span>
                                        <template v-if="itemA.cartVal=='quick'">
                                            <i style="display: none;" :class="'cart-pro-store-'+setId(itemP.speedUp)+itemP.promotionId">仅{{itemP.stockCount}}件</i>
                                        </template>
                                        <template v-else>
                                            <i v-if="itemP.delayDays>0"  :class="'cart-pro-delay-'+setId(itemP.speedUp)+itemP.promotionId">延迟配送</i>
                                        </template>
                                    </p>
                                    <proOpera :itemPro="itemP" :fromState="fromState" :speedUp="itemP.speedUp" :stockCount="itemP.stockCount" :proId="itemP.promotionId" :promoId="itemP.promotionId" :protype="1" :proLimit="itemP.limitCount" :proName="itemP.promotionName"></proOpera>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="itemA.nomalTempCart.products.concat(itemA.nomalTempCart.promotions).length>0">
                        <div class="cart-section">
                            <div class="cart-section-title">
                                <p><em>•</em>常温商品</p>
                                <span>{{itemA.nomMsg}}</span>
                            </div>
                            <div class="cart-section-content">
                                <div v-for="itemP in itemA.nomalTempCart.products" class="item" :class="'item-'+setId(itemP.speedUp)+itemP.proId">
                                    <p>
                                        <span>{{itemP.proName}}</span>
                                        <template v-if="itemA.cartVal=='quick'">
                                            <i style="display: none;" :class="'cart-pro-store-'+setId(itemP.speedUp)+itemP.proId">仅{{itemP.stockCount}}件</i>
                                        </template>
                                        <template v-else>
                                            <i v-if="itemP.delayDays>0" :class="'cart-pro-delay-'+setId(itemP.speedUp)+itemP.proId">延迟配送</i>
                                        </template>
                                    </p>
                                    <proOpera :itemPro="itemP" :fromState="fromState" :speedUp="itemP.speedUp" :stockCount="itemP.stockCount" :proId="itemP.proId" :promoId="itemP.promotionId" :protype="4" :proLimit="itemP.limitBuyCount" :proName="itemP.proName"></proOpera>
                                </div>
                                <div v-for="itemP in itemA.nomalTempCart.promotions" class="item" :class="'item-'+setId(itemP.speedUp)+itemP.promotionId">
                                    <p>
                                        <span>{{itemP.promotionName}}</span>
                                        <template v-if="itemA.cartVal=='quick'">
                                            <i style="display: none;" :class="'cart-pro-store-'+setId(itemP.speedUp)+itemP.promotionId">仅{{itemP.stockCount}}件</i>
                                        </template>
                                        <template v-else>
                                            <i v-if="itemP.delayDays>0" :class="'cart-pro-delay-'+setId(itemP.speedUp)+itemP.promotionId">延迟配送</i>
                                        </template>
                                    </p>
                                    <proOpera :itemPro="itemP" :fromState="fromState" :speedUp="itemP.speedUp" :stockCount="itemP.stockCount" :proId="itemP.promotionId" :promoId="itemP.promotionId" :protype="1" :proLimit="itemP.limitCount" :proName="itemP.promotionName" ></proOpera>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="itemA.soldOut.length>0">
                        <div class="cart-section">
                            <div class="cart-section-content">
                                <div v-for="itemP in itemA.soldOut" class="item">
                                    <p class="item-name"><span>{{itemP.proName||itemP.promotionName}}</span><i>库存不足</i></p>
                                    <em class="free-count" @click.prevent="clearSoldOutPro(itemP.proId||itemP.promotionId,itemP.speedUp)"><i class="icon iconfont icon-delete"></i></em>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="itemA.coldChainCart.frees.concat(itemA.nomalTempCart.frees).length>0">
                        <div class="cart-section">
                            <div class="cart-section-title">
                                <p><em>•</em>赠品</p>
                            </div>
                            <div class="cart-section-content">
                                <template v-for="item in itemA.coldChainCart.frees.concat(itemA.nomalTempCart.frees)">
                                    <div v-for="itemP in item.productList" class="item">
                                        <p class="item-name"><span>{{itemP.proName}}</span></p>
                                        <em class="free-count">x {{itemP.count}}</em>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="itemA.valid.length>0">
                        <div class="cart-section">
                            <div class="cart-section-title">
                                <p><em>•</em>失效商品</p>
                                <span class="clear-pro" @click.stop.prevent="clearInvalid">清空失效商品</span>
                            </div>
                            <div class="cart-section-content">
                                <div v-for="itemP in itemA.valid" class="item">
                                    <p class="item-name"><span>{{itemP.proName||itemP.promotionName}}</span></p>
                                    <em class="free-count">已失效</em>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
                <div class="cart-box-footer">
                    <div class="footer-left">
                        <p>已选<em>({{itemA.totalQuantity}})</em></p>
                        <p class="sub-info">运费: ¥{{itemA.freight}}</p>
                    </div>
                    <div class="cart-footer-box">
                        <div>
                            <p class="footer-price">实付:¥ {{itemA.factPrice}}</p>
                            <p class="sub-info">总额:¥ {{itemA.price}}</p>
                        </div>
                        <span :class="itemA.btnAble=='1'?'btn-able':(itemA.btnAble=='3'?'no-able':'')" @click.stop="toPaySubmit(itemA.cartVal,itemA.btnAble)">
                            去结算<i v-if="itemA.btnAble=='3'">?</i>
                        </span>
                    </div>
                </div>
            </section>
        </template>

        <div class="tem-sold-out" v-if="soldOutBox" @click.stop="">
            <div class="sold-out-content">
                <h2>以下商品在<em>未来7天内有部分缺货</em></h2>
                <p>在购物车中将其中一个缺货的商品删减即可进行结算</p>
                <ul>
                    <li v-for="item in deliverDates">
                        <span>{{setSoldTime(item.time)}}</span>
                        <div class="pro-list">
                            <div class="pro-list-item" v-for="item1 in item.productForms">
                                <h4>{{item1.productName}}</h4>
                                <em v-if="item1.salesCount<=0"><i class="icon iconfont icon-gantanhao"></i>缺货</em>
                                <em v-else class="red">仅剩{{item1.salesCount}}件</em>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="sold-out-btn">
                <span @click="closeSoldOut">去购物车中删减</span>
            </div>
        </div>

    </div>
</template>

<script>
    import proOpera from '@/components/index/product_opera.vue'
    import {setCookie,getPlatFrom} from '@/resource/js/common'
    import {sa} from '@/resource/js/ANALYSIS2'
    
    let CARTSTATE = {generalCart:'gener',quickCart:'quick'};
    let CARTSTATENAME = {generalCart:'常规运送',quickCart:'极速达'};
    let CARTSTATETRANS = ['coldChainCart','nomalTempCart'];
    let CARTSTATETRANSPRO = ['products','promotions','frees'];

    export default{
        data(){
            return{
                activeTab:'gener',
                getPlatFrom:getPlatFrom(),
                fromState:'cart',
                totalQuantity:0,
                soldOutBox:false,
                cartContentBox:true
            }
        },
        watch:{
            showCart(val){
                let wrap = document.getElementById('app');
                if(val){
                    wrap.style.position = 'fixed';
                }else{
                    wrap.style.position = ''
                }
            }
        },
        props:['showCart'],
        computed:{
            cart(){
                return this.$store.getters.cart
            },
            cartS(){
                return this.$store.getters.cartS
            },
            deliverDates(){
                return this.$store.state.cartNew.deliverDates
            }
        },
        components:{
            proOpera
        },
        mounted(){
            this.$store.dispatch('initCartDataInfo',{
                "areaId": '',
                "address": '',
                "needLogin":0,
                "isQuick":false
            })
        },
        methods:{
            setId(item){
                return item!=undefined?item+'-':''
            },
            closeBox(){
                this.soldOutBox = false
                this.cartContentBox = true
                this.$emit('closeB',false)
            },
            closeSoldOut(){
                this.soldOutBox = false
                this.cartContentBox = true
            },
            setPrice(item){
                return parseFloat(item).toFixed(2)
            },
            setSoldTime(date){
                let dateArr = date.split('-')
                dateArr.splice(0,1);
                let mouth = +dateArr[0]+'月'
                let day = +dateArr[1] + '日'
                return mouth+day
            },
            setObjArr(obj){
                let newArr = []
                for(let key in obj){
                    obj[key].time = key;
                    newArr.push(obj[key])
                }
                return newArr
            },
            tabSwitch(val){
                this.activeTab = val
            },
            clearInvalid(){
                let _this = this;
                invokeApi('shoppingcart/removeCartInvalid', {}, 'post', Math.random(), function(res) {
                    _this.$prompt('清除成功',function () {
                        _this.closeBox()
                    })
                })
            },
            clearSoldOutPro(val,speed){
                let _this = this;
                let isQuick = speed=='1'?true:false;

                invokeApi('shoppingcart/removeCartProduct', {salesId:val,areaId:'',address:'',isQuick:isQuick}, 'post', Math.random(), function(res) {
                    _this.$prompt('清除成功',function () {
                        _this.closeBox()
                    })
                })
            },
            toPaySubmit(cart,btn){
                if(btn==3){
                    this.soldOutBox = true
                    this.cartContentBox = false
                    return
                }else if(btn==2){
                    return
                }
                let isQuick = cart=='quick'?1:0;
                this.closeBox();
                sa.track('lcweb',{'lcclick':'购物车_弹窗_结算按钮'});
                window.location.href = '/pages/topay/topay.html?cacheId=&orderSource=0&bindCode=&isQuick='+isQuick;
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../resource/css/color";
    .cart-box{
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.6);
        z-index: 9999;
        &-tab{
            position: absolute;
            top:-.54rem;
            left:0;
            display: flex;
            align-items: flex-end;
            span{
                height: .5rem;
                line-height: .5rem;
                width: 1.36rem;
                text-align: center;
                background: #f1f1f1;
                color: #999999;
                font-size: .2rem;
                display: inline-block;
                margin-right: .1rem;
                border-top-left-radius: .1rem;
                border-top-right-radius: .1rem;
            }
            .active{
                background: #ffffff;
                color: #222222;
                font-size: .24rem;
                line-height: .6rem;
                height: .6rem;
            }
        }
        &-wrap{
            position: absolute;
            bottom: .1rem;
            left: 2%;
            width: 96%;
            background: #ffffff;
            border-radius:.1rem;
            z-index: 1;
        }
        &-header{
            position: absolute;
            top:0;
            left: 0;
            z-index: 9;
            width: 100%;
            height: 1rem;
            background:#ffffff url("./images/alert_cart.png") left center no-repeat;
            background-size: .86rem .6rem;
            padding-right: .2rem;
            box-sizing: border-box;
            border-bottom: 1px solid #f5f5f5;
            border-top-left-radius:.1rem;
            border-top-right-radius:.1rem;
            p{
                text-align: right;
                line-height: 1rem;
                width: 100%;
            }
            .gener-title{
                line-height: .3rem;
                margin: .2rem 0 .1rem;
            }
            .gener-text{
                font-size: .26rem;
                line-height: .2rem;
                color: #e50011;
            }
        }
        .cart-box-container{
            padding:1rem 0 1.1rem;
            max-height: 8rem;
            overflow-x: hidden;
            overflow-y: scroll;
        }
        .cart-section{

            &-title{
                background: #f1f1f1;
                padding:0 .2rem;
                line-height: .7rem;
                display: -webkit-box;
                -webkit-box-pack: justify;
                em{
                    color: $mainColor;
                    margin-right: .1rem;
                }
                span{
                    font-size: .24rem;
                    color: $mainColor;
                }
                span.clear-pro{
                    color: $mainColor;
                    border:1px solid;
                    border-radius: .1rem;
                    padding: .04rem .1rem;
                }
            }
            &-content{
                padding-left: .16rem;
                .item{
                    display: -webkit-box;
                    -webkit-box-pack: justify;
                    -webkit-box-align: center;
                    padding: .14rem .2rem .14rem .1rem;
                    border-bottom: 1px solid #f5f5f5;
                    p{
                        -webkit-box-flex: 1;
                        span{
                            max-width: 3.6rem;
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            color: #979797;
                        }
                        i{
                            position: relative;
                            top:-.05rem;
                            font-size: .22rem;
                            padding: .08rem;
                            border-radius: .08rem;
                            border: 1px solid $mainColor;
                            color: $mainColor;
                            font-style: normal;
                        }
                    }
                    .free-count{

                    }
                }
            }
        }
        &-footer{
            position: absolute;
            bottom:0;
            left: 0;
            width: 100%;
            background: #ffffff;
            display: -webkit-box;
            -webkit-box-pack: justify;
            -webkit-box-align: center;
            border-bottom-left-radius:.1rem;
            border-bottom-right-radius:.1rem;
            .footer-left{
                -webkit-box-flex: 1;
                margin-left: .2rem;
            }
            .cart-footer-box{
                display: -webkit-box;
                -webkit-box-pack: justify;
                -webkit-box-align: center;
                span{
                    display: block;
                    width: 2.2rem;
                    background: #cccccc;
                    color: #ffffff;
                    line-height: 1rem;
                    text-align: center;
                    margin-left: .2rem;
                    font-size: .3rem;
                }
                .btn-able{
                    background: $mainColor;
                }
                .no-able{
                    color: #2c2c2c;
                    i{
                        position: relative;
                        top:-.04rem;
                        margin-left:.1rem;
                        color: #ffffff;
                        width: .3rem;
                        height: .3rem;
                        border-radius: .15rem;
                        font-style: normal;
                        background: #aaaaaa;
                        text-align: center;
                        line-height: .3rem;
                        display: inline-block;
                        font-size: .2rem;
                    }
                }
                .footer-price{
                    color: $mainColor;
                }
            }
            .sub-info{
                color: #999999;
                font-size: .22rem;
            }
        }
        .tem-sold-out{
            width: 6.6rem;
            height: 9rem;
            background: #f6f6f6;
            border-radius: .16rem;
            position: absolute;
            top:50%;
            left: 50%;
            z-index: 1;
            transform: translate(-50%,-50%);

            overflow: hidden;
            .sold-out-content{
                overflow-y: scroll;
                height: 8rem;
            }
            h2{
                font-size: .32rem;
                text-align: center;
                background: #ffffff;
                padding: .36rem 0;
                em{
                    color: $mainColor;
                }
            }
            p{
                font-size: .26rem;
                color: #2c2c2c;
                text-align: center;
                padding: .2rem 0;
                background: #F8F1ED;
            }
            ul{
                li{
                    background: #ffffff;
                    display: flex;
                    font-size: .24rem;
                    padding: .22rem .22rem 0;
                    box-shadow: 0 .04rem .16rem rgba(189,189,189,.5);
                    margin-bottom: .2rem;
                    span{
                        color: #292929;
                        font-weight: bold;
                        width: 1.2rem;
                        display: block;
                        margin-right: .24rem;
                        margin-top: .05rem;
                        text-align: center;
                    }
                    .pro-list{
                        flex: 1;
                        &-item{
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: .22rem;
                            h4{
                                font-weight: normal;
                                font-size: .26rem;
                                color: #878787;
                                width: 3.5rem;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                            em,i{
                                color: $mainColor;
                                font-size: .22rem;
                            }
                            i{
                                margin-right: .05rem;
                            }
                            .red{
                                color: #E48C8C;
                            }
                        }
                    }
                }
            }
            .sold-out-btn{
                position: fixed;
                left: 0;
                bottom: 0;
                background: #ffffff;
                box-shadow: 0 -.04rem .14rem rgba(171,171,171,.5);
                width: 100%;
                span{
                    width: 2.8rem;
                    height: .72rem;
                    display: block;
                    text-align: center;
                    line-height: .72rem;
                    background: #222222;
                    color: #ffffff;
                    font-size: .32rem;
                    border-radius: .16rem;
                    margin: .18rem auto;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/cart-box/cart-box.vue